@if (!this.loading) {
  <!-- CONTENEDOR PRINCIPAL CON SCROLL -->
  <div class="main-container">
    <!-- HEADER STICKY CON TÍTULO Y PESTAÑAS -->
    <div class="sticky-header">
      <div class="header-bar">
        <button irxBoton="secundario" (click)="volver()">
          <mat-icon>arrow_back</mat-icon>
          Volver
        </button>
        <span class="title1">{{ nombreGrupo }}</span>
      </div>

      @if (params) {
        <app-listado-config-evento-usuario
          [params]="params"
        ></app-listado-config-evento-usuario>
      }
    </div>
  </div>
}
